import { useQuery } from "@tanstack/react-query";
import { useParams, useSearchParams } from "react-router-dom";

import { useAuth } from "contexts/AuthContext";

export const useGetOutputPointcloud = (outputId: string | undefined) => {

  const { authApi } = useAuth();
  const result = useQuery({
    queryKey: ["s3", outputId],
    enabled: !!outputId,
    queryFn: async () => {
      const { data } = await authApi.get<PointCloudOutput>(
        `/output/${outputId}/assets` // if outputId is present, fetch the assets for that output fetch the test assets (for arbitrary point cloud testing flow)
      );
      return data;
    },
  });

  return result;
};
